import { render, staticRenderFns } from "./SpyderView.vue?vue&type=template&id=641f7f90&scoped=true"
import script from "./SpyderView.vue?vue&type=script&lang=js"
export * from "./SpyderView.vue?vue&type=script&lang=js"
import style0 from "./SpyderView.vue?vue&type=style&index=0&id=641f7f90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641f7f90",
  null
  
)

export default component.exports